var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('free-inputtable-object-menu',{attrs:{"source":_vm.source,"is-input-method-selectable":_vm.isInputMethodSelectable,"unselectedButtonConfiguration":_vm.unselectedButtonConfiguration}})}
var staticRenderFns = []

export { render, staticRenderFns }